import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    setWorkTimeModel({ commit }, workTimeModel) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/timeAccounts/setWorkTimeModel",
            method: "POST",
            data: workTimeModel
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setAutoModel({ commit }, autoModelId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/timeAccounts/setAutoModel",
            method: "POST",
            data: autoModelId
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getWorkTimeModel({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/timeAccounts/${id}/getTimeAccount`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateTimeAccount({ commit }, startTimeObject) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/timeAccounts/updateTimeAccount",
            method: "POST",
            data: startTimeObject
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setFutureTimeAccount({ commit }, futureTimeAccount) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/timeAccounts/setFutureTimeAccount",
            method: "POST",
            data: futureTimeAccount
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getTimeAccountForUser({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/timeAccounts/getTimeAccount`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getFutureTimeAccount({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/timeAccounts/${userId}/getFutureTimeAccount`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    closeTimeAccount({ commit }, timeAccount) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/timeAccounts/closeTimeAccount`,
            data: timeAccount,
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteTimeAccount({ commit }, timeAccount) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/timeAccounts/deleteTimeAccount`,
            data: timeAccount,
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getHolidayAccount({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/holidayaccount/${data.userId}/${data.year}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    hasHolidayAccount({ commit }, usercode) {
      return Vue.prototype
        .$http({
          url: Vue.prototype.apiUrl + "/api/holidayaccount/" + usercode,
          method: "GET"
        })
        .then((resp) => {
          let hasHolidayAccount = false;
          if (resp.data.Days) {
            hasHolidayAccount = true;
          }
          return hasHolidayAccount;
        })
        .catch((err) => {
          // ToDo: Throw error Message
          return false;
        });
    },
    createHolidayAccount({ commit }, holidayAccount) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/holidayaccount",
            method: "POST",
            data: holidayAccount
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateHolidayAccount({ commit }, holidayAccount) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/holidayaccount/updateHolidayAccount",
            method: "POST",
            data: holidayAccount
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getUserWorkTimeBalance({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/getUserWorkTimeBalance/` + userId,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getTimeDebitForDate({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/timeAccounts/${data.userId}/getTimeDebitForDate/${data.date}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getWorkTimeInfoForDay({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/timeAccounts/${data.userId}/getWorkTimeInfoForDay/${data.date}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    recalculateTimeAccounts({ commit }, date) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/timeAccounts/recalculateTimeAccounts`,
            method: "POST",
            data: date
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    checkIfTimeAccountRecalculationRunning({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/timeAccounts/checkIfTimeAccountRecalculationRunning`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
  modules: {},
  getters: {}
};
